import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentMembersEffects } from './store/tellent-members.effects';
import { TellentMembersNamespace, TellentMembersReducer } from './store/tellent-members.store';

const provideTellentMembersState = provideState(TellentMembersNamespace, TellentMembersReducer);
const provideTellentMembersEffects = provideEffects(TellentMembersEffects);

export const tellentMembersData = [provideTellentMembersState, provideTellentMembersEffects];
